import { Fragment, useState } from "react";
import { ArrowRightCircle, ChevronsRight } from "react-feather";
import { Btn, H6, P } from "../../../../AbstractElements";
import { UXDesigner, WebDesign, WedDesigner } from "../../../../Constants/Constants";
import { BelowsmData } from "../../../../Data/UiKits/Modal";
import CommonModal from "../Common/CommonModal";

const CommonBelowModal = ({title,modalClass,color,}:any) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const data = {isOpen: modal,header: true,footer: true,toggler: toggle,title: title,class: modalClass,bodyClass: "dark-modal"};
  return (
    <Fragment>
      <Btn color={color} outline={true} onClick={toggle}>{title}</Btn>
      <CommonModal modalData={data}>
        <div className="large-modal-header">
          <ChevronsRight />
          <H6>{WebDesign}</H6>
        </div>
        <P className="modal-padding-space">{"We build specialised websites for companies, list them on digital directories, and set up a sales funnel to boost ROI."}</P>
        <div className="modal-details">
          <div className="web-content">
            <H6>{WedDesigner}</H6>
            {BelowsmData &&
              BelowsmData.map((item, index) => (
                <Fragment key={index}>
                  <div className={`d-flex ${item.class}`}>
                    <div className="flex-shrink-0">
                      <ArrowRightCircle className="svg-modal" />
                    </div>
                    <div className="flex-grow-1 ms-2">
                      <P className="m-0">{item.text}</P>
                    </div>
                  </div>
                  {index === 1 && <H6>{UXDesigner}</H6>}
                </Fragment>
              ))}
          </div>
        </div>
      </CommonModal>
    </Fragment>
  );
};

export default CommonBelowModal;
